import * as React from "react";
import { formatMoney } from "../../../shared/api/formatutil";
import { ReceiptResponse } from "../../interfaces/receipt"; 

interface ReceiptDisplayProps {
    receipt: ReceiptResponse;
}

// Gets contents of receipt
const ReceiptDisplay = ({ receipt }: ReceiptDisplayProps) => {
    return (
        <div className="container py-3">
            <div className="row">
                <div className="col-lg-10 col-xxl-8">
                    <h3>Your Receipt</h3>
                    <p>Thank you for your order. Please <a href="/Client">visit your dashboard</a> for more detailed information about your registration.</p>
                    <div className="row mb-2">
                        <div className="col-sm-4 fw-semibold">Description</div>
                        <div className="col-sm-8">{receipt.description}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-4 fw-semibold">Order number</div>
                        <div className="col-sm-8">{receipt.invoiceNumber}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-4 fw-semibold">Date</div>
                        <div className="col-sm-8">{receipt.orderDate}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-4 fw-semibold">Payment</div>
                        <div className="col-sm-8">{formatMoney(receipt.amount)}</div>
                    </div>
               </div>
            </div>
        </div>
    );
};

export default ReceiptDisplay;
